window.jQuery = window.$ = require('jquery');

require('./util/nativeQuery');

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('base/components/menu'));
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('base/components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('base/components/clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('./components/customSelect'));
    require('./components/header').init();
    require('./util/closeFlyouts').init();
    require('./components/login-flyout').init();
    require('./components/stickyHeader').init();
    require('./components/consentTracking').init();
    require('./product/quantity').init();
    // require('./product/quickview').onQuickviewReady();
    require('./analytics/events').init();
    require('./analytics/enhancedEcommerce').init();
    require('./account/accountMenu').init();
    require('./components/localePreferences').init();
    require('./components/subscription').init();
    require('./components/optin').init();
    require('./customCarousel').init();
    require('./evoucher/notification').init();
    require('./components/CaptureSFMCID').init();
});

require('./thirdParty/bootstrap');
require('base/components/spinner');
